// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1tRx8","header":"MergedInvoice_header__3q5db"};